import { useContext } from 'react'
import CountryPicker from 'Components/reusable/InputFields/CountryPicker'
import { CountryCode } from 'types/ids'
import { IPerson } from 'types/userInterfaces'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextCountryField = <T extends AnyObject>({
  field,
  countriesOptions,
  ...rest
}: {
  field: EditableFieldsOfType<T, CountryCode | string | null>
  countriesOptions: { code: string; label: string }[]
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: IPerson | null) => {
    setFields({ [field]: newValue })
  }

  const dataValue = flatData[field] as unknown as string

  return (
    <CountryPicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue}
      label={t(`${localeBase}.${field}`)}
      countriesOptions={countriesOptions}
      {...rest}
    />
  )
}

/**
 * Organization type picker.
 */
